export default __webpack_public_path__ + "static/img_growing_together_1@2x-4022ba20eabdf7859e70897d54698d79.png";